import { render, staticRenderFns } from "./w-btn-next.vue?vue&type=template&id=432d3e53&lang=pug&"
import script from "./w-btn-next.vue?vue&type=script&lang=js&"
export * from "./w-btn-next.vue?vue&type=script&lang=js&"
import style0 from "./w-btn-next.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/rain/projects/themes/achernar/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('432d3e53')) {
      api.createRecord('432d3e53', component.options)
    } else {
      api.reload('432d3e53', component.options)
    }
    module.hot.accept("./w-btn-next.vue?vue&type=template&id=432d3e53&lang=pug&", function () {
      api.rerender('432d3e53', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/widgets/w-btn-next.vue"
export default component.exports